import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

export interface DialogConfigData {
  value?: string;
  title?: string;
  label?: string;
  maxLength?: number;
}

@Component({
  selector: 'met-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {

  value = '';
  title = 'Notiz bearbeiten';
  label = 'Notiz';
  maxLength = 1000;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string | DialogConfigData
  ) {
    if (typeof data === 'string') {
      this.value = data ?? '';
    } else if (data) {
      this.value = data.value ?? '';
      this.title = data.title ?? this.title;
      this.label = data.label ?? this.label;
      this.maxLength = data.maxLength ?? this.maxLength;
    }
  }

  get remainingChars(): number {
    return this.maxLength - (this.value?.length ?? 0);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
